<!--
######################################################################
table
-- thead
---- th(expand-icon); th(row with the headers); th(editButton)
---------------------- tr
------------------------ th* (headers)
---------------------- tr
------------------------ th* (forms)
-- tbody
-- tr*
---- td(expand-icon); td(tr row with the data); td(editButton)
---------------------- tr
------------------------ th* (data)
---------------------- tr
------------------------ th* (expand template)
######################################################################
-->

<table style="width: auto;">
  <thead>
    @if (showSearch) {
      <tr>
        <!-- search input boxes -->
        <th>&nbsp;</th>
        @if (selectable) {
          <th>&nbsp;</th>
        }
        <th [attr.colspan]="header.length">
          <form>
            <table>
              <thead>
                <tr>
                  <th>
                    <ng-container *ngTemplateOutlet="headerSearch"></ng-container>
                    <!--<th *ngFor="let l of header; index as i">
                    <select-checkbox-search [header]="l" [idcontainer]="idtable"></select-checkbox-search>-->
                    <!--<input *ngIf="l.searchtype != 'checkbox'" id="{{idtable}}-search-header-{{i}}" title="Search by {{l.label}}" type="{{l.searchtype}}" placeholder="Search {{l.label}}" (change)="onChangeColumn($event, i)" />
                    <select *ngIf="l.searchtype == 'checkbox'" id="{{idtable}}-search-header-{{i}}" title="Search by {{l.label}}" (change)="onChangeColumn($event, i)">
                      <option>&nbsp;</option>
                      <option typeof="checkbox">Active</option>
                      <option>Inactive</option>
                    </select>-->
                  <!--</th>-->
                  <!--<th>
                  <select-checkbox-search></select-checkbox-search>
                </th>
                <th>
                  <select-checkbox-search></select-checkbox-search>
                </th>-->
              </tr>
            </thead>
          </table>
        </form>
      </th>
      @if (rowEditTemplate||isToShowDeleteButton()) {
        <th>&nbsp;</th>
        } <!-- to edit button -->
      </tr>
    }
  </thead>
</table>




<!--<div id="{{idtable}}" class="divTable">-->
<table style="width: auto;" id="{{idtable}}" class="fixed_headers">
  <!--<div class="divTableHeading">-->
  <thead>
    <tr>
      <th>
        <table>
          <thead>
            <tr>
              @if (!isToShowSearchButton()) {
                <th>&nbsp;</th>
              }
              @if (isToShowSearchButton()) {
                <th>
                  <button class="button-filter" type="button" (click)="showSearchForm()">&nbsp;</button>
                </th>
              }
              @if (selectable) {
                <th><input type="checkbox" (click)="onCheckedAll($event)" /></th>
                } <!-- to select -->
                @for (l of header; track l; let i = $index) {
                  <th title="{{l.title}}">
                    <!--<ng-container *ngTemplateOutlet="headerdata"></ng-container>-->
                    @if (!l.show) {
                      <span>&nbsp;</span>
                    }
                    @if (l.show) {
                      <div class="search">{{l.label}}</div>
                    }
                  </th>
                }
                @if (rowEditTemplate||isToShowDeleteButton()) {
                  <th>&nbsp;</th>
                  } <!-- to edit button -->
                </tr> <!--divTableRow-->
              </thead>
            </table>
          </th>
        </tr>
      </thead> <!--divTableHeading-->

      <tbody>
        <!--class="divTableBody"-->
        @if (newRow) {
          <tr>
            <ng-container *ngTemplateOutlet="rowNewTemplate"></ng-container>
          </tr>
        }

        @for (d of data; track d; let r = $index) {
          <tr id="row-{{idtable}}-{{r}}">
            <!--class="divTableRow"-->
            <!-- table data -->
            <td>
              <table>
                <tbody class="inner">
                  <!-- row to show the form to create a record -->
                  @if (editing[r]) {
                    <tr>
                      <td [attr.colspan]="header.length" style="width:auto;">
                        <ng-container *ngTemplateOutlet="rowEditTemplate; context:{value:d, index:r}"></ng-container>
                      </td>
                    </tr>
                  }
                  @if (!editing[r]) {
                    <tr>
                      @if (collapsible) {
                        <td (click)="onExpandRow($event, r)">
                          @if (!expanded[r]) {
                            <span><strong style="font-size:large;">+</strong></span>
                          }
                          @if (expanded[r]) {
                            <span><strong style="font-size:large;">-</strong></span>
                          }
                        </td>
                      }
                      @if (!collapsible) {
                        <td>&nbsp;</td>
                        } <!-- to expand -->
                        @if (selectable) {
                          <td><input type="checkbox" [checked]="isRowChecked(r)" (click)="onCheck($event, r)" /></td>
                          } <!-- to select -->
                          @for (l of header; track l; let c = $index) {
                            <td [ngClass]="getClass(r, c)" title="{{l.label}}: {{l.title}}" (click)="onCellClick(r, c)">
                              @if (!l.show) {
                                <span>&nbsp;</span>
                              }
                              @if (!l.checkbox&&l.show) {
                                <span>{{getData(r, c)}}</span>
                              }
                              @if (l.checkbox&&l.show) {
                                <span><input type="checkbox" [checked]="isInputChecked(r, c)" value="1" onclick="return false;" /></span>
                              }
                            </td>
                          }
                          @if (rowEditTemplate||isToShowDeleteButton()) {
                            <td>
                              <!-- class="divTableCell"  -->
                              @if (collapsible&&expanded[r]&&onNewChild.observers.length!=0) {
                                <button
                                  type="button"
                                  title="new Child"
                                  class="btn btn-default"
                                  (click)="onRowNewChild(d,r)"
                                  >
                                  +
                                </button>
                              }
                              @if (rowEditTemplate) {
                                <button
                                  type="button"
                                  class="btn btn-default"
                                  [disabled]="editing[r]"
                                  (click)="onRowEdit(d,r)">
                                  {{editLabel}}
                                </button>
                              }
                              @if (isToShowDeleteButton()) {
                                <button
                                  type="button"
                                  title="Delete Record"
                                  class="btn btn-danger"
                                  (click)="onRowDelete(d,r)">
                                  Delete
                                </button>
                              }
                            </td>
                          }
                        </tr>
                      }
                      <tr [ngClass]="expandrowclass[r]">
                        <td>&nbsp;</td> <!-- collapsible-->
                        @if (selectable) {
                          <td>&nbsp;</td>
                          } <!-- selectable-->
                          <td [attr.colspan]="header.length" class="expand-container" style="width:100%; border-color: black; border-style:solid; border-width:1px;">
                            <ng-container *ngTemplateOutlet="rowExpandTemplate; context:{value:d, index:r}"></ng-container>
                          </td>
                          @if (rowEditTemplate||isToShowDeleteButton()) {
                            <td>&nbsp;</td>
                            } <!-- buttons -->
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <!-- divTable data -->
                    <!--<div class="divTableRow" id="rowdata-{{idtable}}" *ngIf="editing[r]">
                  </div>
                  <div class="divTableRow" id="rowdata-{{idtable}}" *ngIf="!editing[r]">
                    <div class="divTableCell" *ngFor="let l of header; index as c" [ngClass]="getClass(r, c)" title="{{l.label}}">
                      <span *ngIf="!l.checkbox">{{getData(r, c)}}</span>
                      <span *ngIf="l.checkbox"><input type="checkbox" [checked]="isInputChecked(r, c)" value="1" onclick="return false;" /></span>
                    </div>
                  </div>-->
                  <!--divTableRow-->
                  <!--<div class="divTableRow" [ngClass]="expandrowclass[r]">
                </div>-->
              </tr>
              } <!-- divTableRow -->
            </tbody> <!--divTableBody-->
          </table> <!--divTable-->
          <ng-container *ngTemplateOutlet="pager"></ng-container>





          <!--<ng-template #pager>-->
          <!-- pager -->
          <!--<ul *ngIf="pager.pages && pager.pages.length" class="pagination">
          <li [ngClass]="{disabled:pager.currentPage === 1}">
            <a (click)="setPage(1)">First</a>
          </li>
          <li [ngClass]="{disabled:pager.currentPage === 1}">
            <a (click)="setPage(pager.currentPage - 1)">Previous</a>
          </li>
          <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
            <a (click)="setPage(page)">{{page}}</a>
          </li>
          <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
            <a (click)="setPage(pager.currentPage + 1)">Next</a>
          </li>
          <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
            <a (click)="setPage(pager.totalPages)">Last</a>
          </li>
        </ul>
      </ng-template>-->
